import { parse } from "date-fns";
import { tr } from "date-fns/locale";

export const TimeConverstion = (data) => {
  if (data) {
    return data >= 0
      ? Math.floor(data / 60).toLocaleString(undefined, {
        minimumIntegerDigits: 2,
      }) +
      ":" +
      Math.abs(data % 60).toLocaleString(undefined, {
        minimumIntegerDigits: 2,
      })
      : Math.ceil(data / 60).toLocaleString(undefined, {
        minimumIntegerDigits: 2,
      }) +
      ":" +
      Math.abs(data % 60).toLocaleString(undefined, {
        minimumIntegerDigits: 2,
      });
  } else {
    return "00:00";
  }
};

export const dateFormat = (data) => {
  return parse(data, "dd/MM/yyyy", new Date());
};

export const stringToHours = (data) => {
  let mins = 0;
  if (data) {
    var array = data.split(":");
    data.includes("-")
      ? (mins = parseInt(array[0]) * 60 - parseInt(array[1]))
      : (mins = parseInt(array[0]) * 60 + parseInt(array[1]));
  }
  return mins;
};

export const GetTimeDateDiff = (start, end) => {
  let minutes = 0;
  if (start && end) {
    if (typeof start === "string") start = start.split(":");
    if (typeof end === "string") end = end.split(":");
    let startDate = new Date(0, 0, 0, start[0], start[1], 0);
    let endDate;
    var today = Number(start[0]) < Number(end[0]) || Number(start[0]) === Number(end[0])
    today ?
      endDate = new Date(0, 0, 0, end[0], end[1], 0) : endDate = new Date(0, 0, 1, end[0], end[1], 0)
    let diff = endDate.getTime() - startDate.getTime();
    minutes = Math.floor(diff / 1000 / 60);
  }
  return minutes;
};

export const CheckLocalStorage = (props) => {
  console.log("NIST related changes");
  return true; // As we have planned to remove local storage check at the time of redirection, sending true always

};

export const saveLocalTechData = (data) => {
  localStorage.setItem("techData", JSON.stringify(data));
};

export const fetchLocalTechData = () => {
  let techData = localStorage.getItem("techData");
  return JSON.parse(techData);
};
export const CheckChangedValue = (stateData, propsData) => {
  var changedflag = false;
  if (propsData) {
    var stateDataKeys = Object.keys(stateData);
    for (var i = 0; i < stateDataKeys.length - 1; i++) {
      if (
        stateData[stateDataKeys[i]] !== propsData[stateDataKeys[i]] &&
        !(stateData[stateDataKeys[i]] instanceof Array)
      ) {
        changedflag = true;
        break;
      } else if (
        stateData[stateDataKeys[i]] instanceof Array &&
        propsData[stateDataKeys[i]] instanceof Array &&
        stateData[stateDataKeys[i]].length > 0
      ) {
        changedflag = checkObjectChangeArray(
          stateData[stateDataKeys[i]],
          propsData[stateDataKeys[i]]
        );
      }
    }
  }
  return changedflag;
};
export const checkObjectChangeArray = (arry1, arry2) => {
  var changedValue = false;
  var arrayKeys = Object.keys(arry1[0]);
  if (arry1.length !== arry2.length) {
    return (changedValue = true);
  }
  for (let j = 0; j < arrayKeys.length - 1; j++) {
    for (let k = 0; k < arry1.length; k++) {
      if (arry1[k][arrayKeys[j]] !== arry2[k][arrayKeys[j]]) {
        changedValue = true;
      }
    }
  }
  return changedValue;
};
